<div class="container-fluid px-0" *ngIf="numberModel && !numberModel.notAllowedMSISDN && sdkInitTexts">
  <div class="row  mx-0 my-0 h-100">
    <div class="col-12 px-0 d-flex justify-content-center">
      <div *ngIf="errorMessage" class="error-message">
        <pa-message [description]="errorMessage" (messageState)="messageState($event)"></pa-message>
      </div>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class="rectangle">
        <p class="title"
           *ngIf="!timerHasEnded">{{this.textService.keyValueMapping('loginNRHeader', 'Üye Ol', sdkInitTexts)}}</p>
        <p class="phone-number" *ngIf="!timerHasEnded">
          <span>{{phoneNumber}}</span>
          <!--          <img class="edit" [src]="'assets/images/png/edit.png'" [srcset]="'assets/images/edit@2x.png 2x, assets/images/edit@3x.png 3x'" alt="logo">--></p>
        <p class="description">{{this.textService.keyValueMapping('smsOtpDescription', 'Telefon numaranıza gelen', sdkInitTexts)}}
          <br>
          <span class="text-style">{{this.textService.keyValueMapping('smsOtpDescriptionContinue', '6 haneli kodu girin.', sdkInitTexts)}}</span>
        </p>
        <form [formGroup]="otpForm">
          <div class="col-12 input-container" *ngIf="!timerHasEnded">
            <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" (keydown)="addOrDeleteCss($event)"
                          [config]="config"></ng-otp-input>
            <mat-error
              *ngIf="submitted && otpForm.controls.otp.errors && otpForm.controls.otp.errors.required">
              {{this.textService.keyValueMapping('msgLoginOtp', 'Lütfen Otp\'yi Giriniz.', sdkInitTexts)}}
            </mat-error>
            <mat-error
              *ngIf="submitted && otpForm.controls.otp.errors && otpForm.controls.otp.errors.minlength">
              {{this.textService.keyValueMapping('msgLoginOtpRule', '4 haneli Otp\'yi giriniz.', sdkInitTexts)}}
            </mat-error>
          </div>
          <div class="col-12 px-0 d-flex"><span
            class="otp-description"
            *ngIf="!timerHasEnded && !numberModel.pinSuspend">{{this.textService.keyValueMapping('smsOtpCode', 'Kodunuz', sdkInitTexts)}}
            <label><nz-countdown [nzValue]="deadline" (nzCountdownFinish)="stop()" [nzFormat]="'mm:ss'"
                                 [nzValueStyle]="{'font-weight': '300'}"></nz-countdown></label> {{this.textService.keyValueMapping('smsOtpTimerText', 'saniye içinde şifrenizi giriniz.', sdkInitTexts)}}</span>
          </div>
          <div class="col-12 px-0 d-flex">
            <button *ngIf="!timerHasEnded && !numberModel.pinSuspend" type="submit" class="button-style" (click)="checkOtp()"><span
              class="text-style">{{this.textService.keyValueMapping('loginNRButton', 'Devam Et', sdkInitTexts)}}</span>
            </button>
            <button *ngIf="timerHasEnded || numberModel.pinSuspend" class="button-style"
                    (click)="sendOtpAgain()"><span
              class="text-style">{{this.textService.keyValueMapping('sendAgain', 'Tekrar Gönder', sdkInitTexts)}}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
